import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map'
import { TranslateService } from "@ngx-translate/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {MonumentDto} from "../dtos/monumentDto";
import {Observable} from "rxjs";

@Injectable()
export class ApiConfigService {
    private tokenType = "";
    private accessToken = "";
    private headers: HttpHeaders;
    options: any;

    constructor(private http: HttpClient, private translate: TranslateService) {
    }

    private initRequest(headers?: HttpHeaders) {
        if (headers) {
            this.headers = headers;
        } else {
            this.tokenType = sessionStorage.getItem("tokenType");
            this.accessToken = sessionStorage.getItem("accessToken");
            this.headers = new HttpHeaders().set('Authorization', this.tokenType + " " + this.accessToken);
            this.headers.append('Language', this.translate.getDefaultLang() + "");
        }
        this.options = {headers: this.headers};
    }

    get<T>(url: string, params?: any, options?: any) {
        this.initRequest();
        this.options.params = params;
        this.options = Object.assign({}, this.options, options);
        return this.http.get<T>('/' + url, this.options) as unknown as Observable<T>;
    }

    delete(url: string) {
        this.initRequest();
        return this.http.delete('/' + url, this.options);
    }

    post(url: string, body: any, options?: any) {
        this.initRequest();
        this.options = Object.assign({}, this.options, options);
        return this.http.post('/' + url, body, this.options);
    }

    getUrl(): string {
        return '/'
    }
}
